import { InputSearchPro } from 'components/InputSearch';
import { empresaToString } from 'utils/padronesToString';
import BusquedaAvanzadaPadrones from 'views/Recaudacion/Caja/BusquedaAvanzadaPadrones';
import { padronesEnum } from '../enums';

const fieldsInfo = {};

const tabs = [
  {
    title: null,
    fields: [
      'empresa',
      'fecha_de_contratacion',
      'metros_contratados',
      'requiere_pintura',
      'requiere_senalamiento',
      'tipo_de_zona_exclusiva',
    ],
  },
];

const configs = {
  empresa: {
    advanced: true,
    control: InputSearchPro,
    advancedComponent: BusquedaAvanzadaPadrones,
    advancedComponentProps: { tipoDePadron: padronesEnum.EMPRESA, allowAdd: false },
    advancedComponentName: 'BusquedaAvanzadaPadrones',
    label: 'Empresa',
    tooltip: 'Búsqueda por Razón social',
    resultProps: {
      name: 'empresa',
      label: 'Empresa',
      render: (empresa) => empresaToString(empresa),
    },
  },
  fecha_de_contratacion: {
    formItemProps: {
      label: 'Fecha de contratación',
      required: true,
    },
  },
  metros_contratados: {
    formItemProps: {
      label: 'Metros Contratados',
      required: true,
    },
  },
  requiere_pintura: {
    formItemProps: {
      label: '¿Requiere pintura?',
      required: true,
    },
  },
  requiere_senalamiento: {
    formItemProps: {
      label: '¿Requiere señalamientos?',
      required: true,
    },
  },
  tipo_de_zona_exclusiva: {
    formItemProps: {
      label: 'Tipo de zona exclusiva',
      required: true,
    },
  },
};

const forbiddenProps = [];

export default {
  configs,
  forbiddenProps,
  fieldsInfo,
  tabs,
};
